import { setTag, startTransaction, configureScope } from '@sentry/react'
import { useSelector } from 'react-redux'
import { selectIsVectorMap } from '../../store/map/map.selectors'
import { useAction } from '../utils/react-redux'
import { sendMapLoadingTime } from '../../store/map/map.actions'
import debug from 'debug'
import { useEffectWithMapContext } from './MapContext'
import { isWebglSupported } from './map.utils'

const d = debug('map')

const useMapPerfMetrics = () => {
  const vectorMap = useSelector(selectIsVectorMap)
  const execFinishMapLoading = useAction(sendMapLoadingTime)

  useEffectWithMapContext(map => {
    setTag('mapType', vectorMap ? 'vector' : 'raster')

    const mapHasGoodSupport = isWebglSupported()
    if (d.enabled) d('goodSupport', mapHasGoodSupport)
    setTag('mapGoodSupport', String(mapHasGoodSupport))

    const transaction = startTransaction({ name: 'map' })
    configureScope(scope => scope.setTransactionName('map'))

    const spanStyle = transaction.startChild({ op: 'style' })
    const spanLoad = transaction.startChild({ op: 'load' })
    map.once('styledata', () => {
      spanStyle.finish()
    })
    map.once('load', () => {
      spanLoad.finish()
      transaction.finish()

      const { startTimestamp = 0, endTimestamp = 0 } = spanLoad
      const loadTime = endTimestamp - startTimestamp
      if (d.enabled) d('loadTime:', loadTime)
      execFinishMapLoading({ loadTime, mapHasGoodSupport })
    })
  }, [])
}

export default useMapPerfMetrics
